import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const WebsiteBuilderAndroid: React.FC = () => (
  <SEOLandingPage
    title="Website Builder for Android — Build Websites from Your Phone | Cosmovex"
    metaDescription="WebEva is a website builder for Android. Write HTML, CSS, and JavaScript, preview in real time, and publish websites directly from your phone."
    ogTitle="Website Builder for Android — WebEva"
    h1="Website Builder for Android"
    intro="Build real websites from your phone. WebEva gives you a full HTML/CSS/JavaScript editor with live preview — design, code, and publish without touching a laptop."
    paragraphs={[
      "Building a website on a phone sounds impractical until you try WebEva. The app combines a code editor with a real browser preview in a split-pane layout designed for mobile. You write HTML on one side, and the rendered result updates on the other — the same feedback loop you'd have in VS Code, optimized for touch.",
      "WebEva supports the full web stack: semantic HTML5, modern CSS including Flexbox and Grid, and vanilla JavaScript with DOM manipulation. You can reference Google Fonts, external CSS frameworks like Bootstrap or Tailwind via CDN, and external JavaScript libraries — the same way you would in a desktop project.",
      "The AI-powered features help when you're stuck. Describe what you want — 'a centered card with a drop shadow and gradient background' — and get a starting point. Refine the generated code by hand, or describe further changes. For developers, this accelerates prototyping. For beginners, it lowers the barrier to get something working quickly.",
      "When your site is ready, WebEva can export it as a ZIP file or deploy it directly to supported hosting platforms. The files are standards-compliant HTML — not locked into a proprietary format, not tied to WebEva's servers.",
    ]}
    features={[
      "Split-pane code editor and live browser preview",
      "HTML5, CSS3, and JavaScript support",
      "Flexbox and CSS Grid layout tools",
      "CDN library support (Bootstrap, Tailwind, jQuery)",
      "AI-assisted code generation and editing",
      "Responsive design preview for mobile and desktop",
      "Export as ZIP or deploy directly",
      "File manager for multi-file projects",
      "Syntax highlighting and code completion",
      "Offline editing — preview works without internet",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.webeva"
    icon="/images/webeva.png"
    appName="WebEva"
    accentColor="#A8720E"
    canonicalPath="/website-builder-android"
  />
);

export default WebsiteBuilderAndroid;
